
  import { persistReducer } from "redux-persist";
  import storage from "redux-persist/lib/storage";
import { LOGIN_SUCCESS,LOG_OUT,USER_LOADED } from "../../actions/type";
  
  // Auth intial state
  const initialAuthState = {
    user: undefined,
    authToken: undefined,
    isLoading: true,
  };
  
  export const reducer = persistReducer(
    // Set persist key
    {
      storage,
      key: "v713-demo1-auth",
      whitelist: ["user", "authToken"],
    },
  
    (state = initialAuthState, action) => {
      switch (action.type) {
        case LOGIN_SUCCESS: {
          const { authToken } = action.payload;
          return { authToken, user: undefined, isLoading: false };
        }
        case USER_LOADED: {
          const {user} = action.payload;
          return { ...state, user,isLoading: false };
        }
        case LOG_OUT: {
          return { ...initialAuthState };
        }
        default:
          return state;
      }
    }
  );

 
  
  // actions exports
  export const actions = {
    login: (authToken) => ({ type: LOGIN_SUCCESS, payload: { authToken } }),
    fulfillUser: (user) => ({ type: USER_LOADED, payload: { user } }),
  };
  